export const DIRECTORY_PRICING_PAGE = {
  title: "Directory Listing Pricing",
  slug: "pricing",
  pageKey: "pricing",
  navLabel: "Pricing",
  metaTitle: "Directory Listing Pricing | My Town Spotlight",
  metaDescription:
    "Choose a directory listing plan to help local customers find and contact your business.",
};

export const DIRECTORY_LISTING_TIERS = [
  {
    key: "basic",
    name: "Basic",
    price: "Free",
    priceSubtext: "",
    badge: null,
    description: "Get listed in the local business directory with essential contact information.",
    ctaLabel: "Claim Free Listing",
    ctaHref: "/claim/new?plan=basic",
    features: [
      "Business name",
      "Business category",
      "Address or service area",
      "Phone number",
      "Website link",
      "Business hours",
      "Short business description",
      "Map placement",
    ],
  },
];

export const DIRECTORY_PRICING_VALUE_BLOCKS = [
  {
    title: "Be Discoverable",
    description: "Appear in the local directory when customers browse businesses by category.",
  },
  {
    title: "Build Trust",
    description: "Show business details, photos, offers, and contact options in one local profile.",
  },
  {
    title: "Stand Out",
    description: "Upgrade to featured or spotlight placement for more visibility.",
  },
];

export const DIRECTORY_PRICING_COMPARISON = [];

export const DIRECTORY_PRICING_FAQS = [
  {
    question: "Is the Basic listing really free?",
    answer:
      "Yes. Basic listings give local businesses a simple directory presence with essential contact information.",
  },
  {
    question: "Can I upgrade later?",
    answer:
      "Yes. Businesses can start with Basic and upgrade to Featured or Spotlight when they want more visibility.",
  },
  {
    question: "Do I need a website?",
    answer:
      "No. A directory listing can serve as a simple local profile with your phone number, services, hours, and contact options.",
  },
  {
    question: "Can I promote deals or coupons?",
    answer:
      "Yes. Featured and Spotlight listings include promotional deal or coupon visibility.",
  },
];

export const DEFAULT_DIRECTORY_PRICING_CONTENT = {
  hero: {
    eyebrow: "Directory Listing Pricing",
    title: "Get Found by Local Customers",
    description:
      "Choose a directory listing plan that helps people discover your business, learn what you offer, and contact you when they are ready to buy.",
    primaryCta: { label: "Claim Free Listing", href: "/claim/new?plan=basic" },
    secondaryCta: { label: "Compare Plans", href: "#compare-plans" },
  },
  valueBlocks: DIRECTORY_PRICING_VALUE_BLOCKS,
  tiers: DIRECTORY_LISTING_TIERS,
  comparison: DIRECTORY_PRICING_COMPARISON,
  faqs: DIRECTORY_PRICING_FAQS,
  meta: {
    title: DIRECTORY_PRICING_PAGE.metaTitle,
    description: DIRECTORY_PRICING_PAGE.metaDescription,
  },
};

export const DEFAULT_PRICING_NAV_ITEM = {
  label: "Pricing",
  href: "/pricing",
  location: "both",
  isEnabled: true,
  sortOrder: 35,
  isSystem: true,
};
